import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';

function UserSMSDisclosure({ showDisclosure, setShowDisclosure }) {
  return (
    <Box>
      <button
        type="button"
        onClick={() => setShowDisclosure(true)}
        style={{
          background: 'none',
          border: 'none',
          color: '#1976d2',
          textDecoration: 'underline',
          cursor: 'pointer',
          padding: 0,
          font: 'inherit',
        }}>
        Disclosure
      </button>
      <Dialog open={showDisclosure} onClose={() => setShowDisclosure(false)}>
        <DialogTitle>SMS Opt-In Disclosure</DialogTitle>
        <DialogContent>
          <Typography>
            Would you like to receive SMS updates about your appointment?
          </Typography>
          <ul style={{ margin: 0, padding: '10px 0 0 17px' }}>
            <li>
              Your phone number will remain private and not be shared with the
              Service Company or sold or disclosed to third parties for
              marketing or promotional purposes.
            </li>
            <li>
              Messages may be stored and monitored for quality assurance and
              training purposes.
            </li>
            <li>
              Msg & Data rates may apply. Msg frequency varies based on service
              activity. Reply HELP for help. You can reply STOP at any time to
              unsubscribe.
            </li>
            <Stack
              sx={{ justifySelf: 'center', mt: 2 }}
              direction="row"
              spacing={2}>
              <a target="_blank" href="/legal/terms">
                Terms
              </a>
              <a target="_blank" href="/legal/privacy">
                Privacy
              </a>
            </Stack>
          </ul>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button variant="contained" onClick={() => setShowDisclosure(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default UserSMSDisclosure;
